import * as React from 'react';
import { useGetRoadCarrierQuery } from "../../../apis/RoadCarrier.api";
import { PrimaryRoadCarrier, RoadCarrier } from "../../../types/models/RoadCarrier";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: RoadCarrier;
};

export const RoadCarrierNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const RoadCarrierName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetRoadCarrierQuery(PrimaryRoadCarrier.fromId(id))
    return (<RoadCarrierNameDisplay data={data}/>)
}

export default RoadCarrierName;
